var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-10-23
 * @brief MyAccount 컴포넌트
 *
 *
 ********************************************************************/
import { useEffect, useState } from "react";
//
import AlertPop from "@components/common/popup/AlertPop";
import UserWithdrawal from "@layout/header/UserWithdrawal";
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue } from "recoil";
import { alertState } from "../../../recoil/assessmentState";
import { langId } from "../../../recoil/langState";
import { userInfoLoginState } from "../../../recoil/userState";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
export default function MyAccount(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const langIds = useRecoilValue(langId);
    //
    const [display, setDisplay] = useState(false);
    const [password, setPassword] = useState("");
    // 새비밀번호
    const [passwordNew, setPasswordNew] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [zoneName, setZoneName] = useState("");
    const [department, setDepartment] = useState("");
    const [classificationItem, setclassificationItem] = useState([]);
    const [classificationCode, setClassificationCode] = useState(null);
    const [resErrorCode, setResErrorCode] = useState(200);
    const [resErrorMsg, setResErrorMsg] = useState([{ field: "", msg: "" }]);
    const [errorList, setErrorList] = useState([]);
    const [errorListNew, setErrorListNew] = useState([]);
    const [alert, setAlert] = useRecoilState(alertState);
    const [resPasswordMsg, setResPasswordMsg] = useState("");
    // 새비밀번호
    const [resPassworNewdMsg, setResPasswordNewMsg] = useState("");
    const [resConfirmPasswordMsg, setResConfirmPasswordMsg] = useState("");
    // 업종구분
    const { data: data } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        httpMethod: "GET",
        appPath: `/user/classification`,
        appQuery: {
            langId: langIds,
        },
        userToken: userInfo.loginInfo.token,
        watch: langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setclassificationItem(data.body);
            }
            else {
                // api if need error handle
                setErrorList(data.errorList);
            }
        }
    }, [data]);
    function displayChang(e) {
        if (display === false) {
            setDisplay(true);
        }
        else {
            setDisplay(false);
            CUTIL.jsclose_Popup("pop-myaccount");
            setPassword("");
            setPasswordNew("");
            setConfirmPassword("");
            setResPasswordNewMsg("");
            setResPasswordMsg("");
            setResConfirmPasswordMsg("");
        }
    }
    useEffect(() => {
        setClassificationCode(userInfo.classificationCode);
        setPhoneNumber(userInfo.phoneNumber);
        setZoneName(userInfo.zoneName);
        setDepartment(userInfo.department);
    }, [userInfo]);
    function onClickSave(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "PUT",
                appPath: "/user",
                appQuery: {
                    userId: userInfo.userId,
                    userName: userInfo.userName,
                    phoneNumber: phoneNumber,
                    zoneName: zoneName,
                    department: department,
                    nickName: userInfo.nickName,
                    classificationCode: classificationCode, // 20221031 업종 추가
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    CUTIL.jsclose_Popup("pop-myaccount");
                    setAlert(Object.assign(Object.assign({}, alert), { header: t("라벨.수정"), divTag: t("라벨.정보가변경되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setResErrorCode(data.codeNum);
                    setResErrorMsg(data.errorList);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function handleSetPhoneNumber(e) {
        setErrorList(errorList.filter((err) => err.field !== "phoneNumber"));
        setPhoneNumber(e.target.value);
    }
    function handleSetZoneName(e) {
        setErrorList(errorList.filter((err) => err.field !== "zoneName"));
        setZoneName(e.target.value);
    }
    function handleSetPassword(val) {
        setErrorList(errorList.filter((err) => err.field !== "password"));
        setPassword(val);
    }
    // password 확인
    function OnChangepasswordNew(e) {
        setErrorListNew(errorListNew.filter((err) => err.field !== "password"));
        setPasswordNew(e.target.value);
    }
    function OnChangeConfirmPasswordNew(e) {
        setErrorListNew(errorListNew.filter((err) => err.field !== "confirmPassword"));
        setConfirmPassword(e.target.value);
    }
    function onClickValid(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "GET",
                appPath: `/auth/password/valid`,
                appQuery: {
                    password: password,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setResPasswordMsg(data.data.msg);
                    // 신규 비밀번호 체크
                    passWordChang(e, data.body.token);
                }
                else {
                    setResErrorCode(data.codeNum);
                    setResErrorMsg(data.errorList);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function passWordChang(e, token) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            if (passwordNew == confirmPassword) {
                data = yield HttpUtil.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/auth/password/change`,
                    appQuery: {
                        password: passwordNew,
                        token: token,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setAlert(Object.assign(Object.assign({}, alert), { header: t("라벨.비밀번호변경"), divTag: t("라벨.비밀번호가변경되었습니다") }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        displayChang(e);
                    }
                    else {
                        setResErrorCode(data.codeNum);
                        setResErrorMsg(data.errorList);
                        if (passwordNew == "") {
                            setErrorListNew(data.errorList);
                        }
                        else {
                            setErrorListNew([
                                { field: "password", msg: data.errorList[0].msg },
                                { field: "confirmPassword", msg: data.errorList[0].msg },
                            ]);
                        }
                    }
                }
            }
            else {
                setErrorListNew([
                    { field: "password", msg: t("라벨.비밀번호가일치하지않습니다") },
                    { field: "confirmPassword", msg: t("라벨.비밀번호가일치하지않습니다") },
                ]);
            }
        });
    }
    function closePop(id) {
        setErrorList([]);
        setErrorListNew([]);
        setClassificationCode(userInfo.classificationCode);
        setPhoneNumber(userInfo.phoneNumber);
        setZoneName(userInfo.zoneName);
        setDepartment(userInfo.department);
        CUTIL.jsclose_Popup(id);
    }
    function classificationCodeSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HttpUtil.PromiseHttp({
                httpMethod: "GET",
                appPath: `/user/classification`,
                appQuery: {
                    langId: langIds,
                },
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setclassificationItem(data.body);
                }
                else {
                    // api if need error handle
                    setErrorList(data.errorList);
                }
            }
        });
    }
    function handleSetclassIficationCode(code) {
        setErrorList(errorList.filter((err) => err.field !== "classificationId"));
        setClassificationCode(code);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "pop-myaccount", className: "popup-layer js-layer layer-out hidden popup-basic myaccount" }, { children: [!display ? (_jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: "My Account" }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => closePop("pop-myaccount") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }))) : (
                    // 비밀번호 수정 화면
                    _jsxs("div", Object.assign({ className: "popup__head" }, { children: [_jsx("h1", { children: t("라벨.비밀번호변경") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => displayChang(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }))), !display ? (_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("form", Object.assign({ action: "", method: "", name: "popmyaccount" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-9" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userId2" }, { children: t("라벨.사용자타입") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "radioBox" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd1" }, { children: [_jsx("input", { type: "radio", id: "rd1", name: "rd", disabled: true, checked: userInfo.role == CONST.USERROLE_ADMIN ? true : false }), "Admin"] })), _jsxs("label", Object.assign({ htmlFor: "rd2" }, { children: [_jsx("input", { type: "radio", id: "rd2", name: "rd", disabled: true, checked: userInfo.role == CONST.USERROLE_ENGINEER ? true : false }), "Engineer"] })), _jsxs("label", Object.assign({ htmlFor: "rd3" }, { children: [_jsx("input", { type: "radio", id: "rd3", name: "rd", disabled: true, checked: userInfo.role == CONST.USERROLE_SUPER ? true : false }), "SuperUser"] })), _jsxs("label", Object.assign({ htmlFor: "rd4" }, { children: [_jsx("input", { type: "radio", id: "rd4", name: "rd", disabled: true, checked: userInfo.role == CONST.USERROLE_USER ? true : false }), "User"] }))] })) }))] }), _jsxs("li", { children: [_jsxs("label", Object.assign({ htmlFor: "userId2" }, { children: ["E-mail (", t("라벨.아이디"), ")"] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "userId2", disabled: true, value: userInfo.email }) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userpw" }, { children: t("라벨.비밀번호") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-txt js-open", "data-pop": "pop-myaccount-pass", onClick: (e) => displayChang(e) }, { children: _jsx("span", { children: t("라벨.비밀번호변경") }) })) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "username3" }, { children: t("라벨.이름") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "username3", disabled: true, value: userInfo.userName }) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userphone2", className: "star" }, { children: t("라벨.연락처") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "tel", id: "userphone2", name: "phone", placeholder: "\uC22B\uC790\uB9CC \uC785\uB825\uD558\uC138\uC694", value: phoneNumber, onChange: (e) => handleSetPhoneNumber(e), className: errorList.filter((err) => err.field === "phoneNumber").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "phoneNumber").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userId3" }, { children: t("라벨.회사") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "userId3", disabled: true, value: userInfo.companyName || "" }) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "part" }, { children: t("라벨.부서") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsx("input", { type: "text", id: "part", value: department || "", onChange: (e) => setDepartment(e.target.value) }) }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "part", className: "star" }, { children: t("라벨.업종") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: `select ${errorList.filter((err) => err.field === "classificationId").length > 0 ? "input-error" : ""}`, onClick: (e) => classificationCodeSel(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: userInfo.classification })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: classificationItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => handleSetclassIficationCode(list.code) }, { children: list.classification }), "class_" + idx.toString()))) })] })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "classificationId").map((err) => err.msg) }))] }))] })] })) })) }))) : (
                    // 비밀번호 수정화면
                    _jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("form", Object.assign({ action: "", method: "", name: "popmyaccount" }, { children: _jsxs("ul", Object.assign({ className: "form__input mt-9" }, { children: [_jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userPw1" }, { children: t("라벨.현재비밀번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "password", id: "userPw1", value: password, onChange: (e) => handleSetPassword(e.target.value), className: errorList.filter((err) => err.field === "password").length > 0
                                                            ? "input-error"
                                                            : resPasswordMsg == "success"
                                                                ? "input-ok"
                                                                : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: password ? t("라벨.비밀번호가일치하지않습니다") : t("라벨.필수항목을입력하지않으셨습니다") }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userPw2" }, { children: t("라벨.새비밀번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("input", { type: "password", id: "userPw2", value: passwordNew, placeholder: t("라벨.비밀번호입력"), onChange: (e) => OnChangepasswordNew(e), className: errorListNew.filter((err) => err.field === "password").length > 0 ? "input-error" : "" }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorListNew.filter((err) => err.field === "password").map((err) => err.msg) }))] }))] }), _jsxs("li", { children: [_jsx("label", Object.assign({ htmlFor: "userPw3" }, { children: t("라벨.새비밀번호확인") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [!passwordNew && _jsx("input", { type: "text", disabled: true, readOnly: true }), passwordNew && (_jsx("input", { type: "password", id: "userPw3", value: confirmPassword, placeholder: t("라벨.비밀번호입력"), onChange: (e) => OnChangeConfirmPasswordNew(e), className: errorListNew.filter((err) => err.field === "confirmPassword").length > 0 ? "input-error" : "" })), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorListNew.filter((err) => err.field === "confirmPassword").map((err) => err.msg) }))] }))] })] })) })) }))), !display ? (_jsxs("div", Object.assign({ className: "popup__footer " }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-linegray js-open", "data-pop": "pop-withdrawal", onClick: (e) => CUTIL.jsopen_Popup(e) }, { children: _jsx("span", Object.assign({ "data-pop": "pop-withdrawal" }, { children: t("라벨.탈퇴하기") })) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => onClickSave(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] }))) : (_jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => displayChang(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => onClickValid(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })))] })), _jsx(UserWithdrawal, { path: CONST.URL_MONITORING }), _jsx(AlertPop, {})] }));
}
